import React from "react";
import Tasks from "../../Pages/Manager/Tasks";

const ActionOnApplications = () => {
    
  return (
    <>
      <Tasks />
    </>
  );
};

export default ActionOnApplications;
